import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { ShellService } from 'src/app/shell/shell.service';

@Component({
  selector: 'app-chauffeur-portal',
  templateUrl: './chauffeur-portal.component.html',
  styleUrls: ['./chauffeur-portal.component.scss']
})
export class ChauffeurPortalComponent implements OnInit {

  private readonly apiPath: string = '/api/chauffeurs';
  vm$: Observable<IPortalPageViewModel>;

  constructor(protected shellService: ShellService, protected route: ActivatedRoute, private commonService: CommonService, private location: Location,
    private authService: AuthService) { }

  ngOnInit(): void {
    const driverCode: string = this.route.snapshot.paramMap.get("driverCode");
    this.vm$ = this.loadPage$('page-load', { driverCode: driverCode});
  }

  /**
   * 
   * @returns 
   */
  private loadPage$(action: string, paramData): Observable<IPortalPageViewModel> {
    return this.commonService.getData('PageCommand', 'chauffeur-portal', action, paramData, '/api/chauffeurs').pipe(
      map((v: IPortalPageViewModel) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };
        
        if (ret.data) {
          
        }

        
        return ret;
      })
    );
  }

  
  refreshPage() {
    const driverCode: string = this.route.snapshot.paramMap.get("driverCode");
    this.vm$ = this.loadPage$('page-load', { driverCode: driverCode});
    this.authService.userInRole;
  }

  goBack() {
    this.location.back();
  }
}


/**
 * 
 */
interface IPortalPageViewModel {
  data?: {  };
  workingText?: string;
  errorText?: string;
  isValid?: boolean;
}

